/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Requestacceptedtoast2Inputs */

const en_requestacceptedtoast2 = /** @type {(inputs: Requestacceptedtoast2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} is in`)
};

const de_requestacceptedtoast2 = /** @type {(inputs: Requestacceptedtoast2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ist dabei`)
};

/**
* | output |
* | --- |
* | "{name} is in" |
*
* @param {Requestacceptedtoast2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestacceptedtoast2 = /** @type {((inputs: Requestacceptedtoast2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestacceptedtoast2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestacceptedtoast2(inputs)
	return de_requestacceptedtoast2(inputs)
});
export { requestacceptedtoast2 as "requestAcceptedToast" }